// client/src/components/clientPortal/PortalLayout.js
import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useClientPortalAuth } from '../../hooks/useClientPortalAuth';
import { usePortalPwa, InstallPrompt } from './PwaSupport';
import useSiteBrand, { SiteBar } from '../../hooks/useSiteBrand';

const PortalLayout = () => {
    const { logout } = useClientPortalAuth();
    // Menu only; the server decides what each account may open (middleware/clientPortalAuth).
    let kind = 'client';
    try { kind = localStorage.getItem('clientPortalKind') || 'client'; } catch { /* storage blocked */ }
    usePortalPwa();
    const site = useSiteBrand();          // Florida: a yellow "Florida" bar on top; Illinois unchanged
    return (
        <div className="min-h-screen bg-slate-100">
            <SiteBar brand={site} />
            <header className="bg-white shadow-sm">
                <div className="max-w-4xl mx-auto flex flex-wrap justify-between items-center gap-2 min-h-16 py-3 px-4 sm:px-6">
                    <div className="flex flex-wrap items-baseline gap-x-5 gap-y-1">
                        <Link to="/client-portal/dashboard" className={`text-lg font-bold text-slate-800 ${site ? `rounded px-1.5 ${site.accentClass}` : ''}`}>{site ? `My ${site.siteName} Portal` : 'My BREC Portal'}</Link>
                        {kind !== 'visitor' && <Link to="/client-portal/dashboard" className="text-sm text-slate-600 hover:text-slate-900">Transactions</Link>}
                        {kind !== 'visitor' && <Link to="/client-portal/property-search" className="text-sm text-slate-600 hover:text-slate-900">Site Search</Link>}
                        <Link to="/client-portal/my-properties" className="text-sm text-slate-600 hover:text-slate-900">My Properties</Link>
                        <Link to="/client-portal/my-listings" className="text-sm text-slate-600 hover:text-slate-900">My Listings</Link>
                        <Link to="/properties" className="text-sm text-slate-600 hover:text-slate-900">Search Properties</Link>
                    </div>
                    <button onClick={logout} className="px-4 py-2 text-sm font-medium text-white bg-slate-800 rounded-md hover:bg-slate-900">Log Out</button>
                </div>
            </header>
            <main className="max-w-4xl mx-auto p-4 sm:p-6">
                <InstallPrompt />
                <Outlet />
            </main>
        </div>
    );
};

export default PortalLayout;
